import React from 'react';
import { Card } from './ui/Card';
import { Heart, Zap, Users } from 'lucide-react';
const principles = [{
  title: 'Automatisierung mit Herz',
  description: 'Technologie soll unterstützen, nicht ersetzen. Persönlicher Support ist bei mir Standard, nicht Extra.',
  icon: Heart
}, {
  title: 'Praxis statt Theorie',
  description: 'Wir entwickeln keine Systeme im Elfenbeinturm. Jede Funktion wurde in der Praxis getestet und optimiert.',
  icon: Zap
}, {
  title: 'Echte Partnerschaft',
  description: 'Du arbeitest direkt mit mir zusammen. Keine anonymen Support-Tickets, sondern echte Partnerschaft auf Augenhöhe.',
  icon: Users
}];
export function PhilosophySection() {
  return <section className="py-20 bg-[#0A0E27]" data-id="element-200" data-mp="1z3o1pwhkxfcx">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-201" data-mp="2e05b4i67kjwu">
        <div className="text-center mb-16" data-id="element-202" data-mp="2e0n8xj8ir66v">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-203" data-mp="291u1o8jtsbf5">
            Mein Ansatz
          </h2>
          <div className="h-1 w-20 bg-[#FF5722] mx-auto rounded-full" data-id="element-204" data-mp="2gzrgf3z3b4qo"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-205" data-mp="2lxax0aj9ftls">
          {principles.map((item, index) => <div key={index} className="text-center group" data-id="element-206" data-mp="2pympqoxfkuy7" data-mpi={index}>
              <div className="w-16 h-16 mx-auto bg-[#141B3A] rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300 border border-[#1E293B] group-hover:border-[#FF5722]" data-id="element-207" data-mp="2uyr9qoxjs7t6">
                <item.icon className="w-8 h-8 text-[#FF5722]" data-id="element-208" data-mp="34wf6tlimlrei" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-209" data-mp="39nx5u4139hwu">
                {item.title}
              </h3>
              <p className="text-[#94A3B8] leading-relaxed" data-id="element-210" data-mp="3dps40znq3f6e">
                {item.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}